import { FlagType } from '~/flags/flags';
import { getFlag, useFlag } from '~/flags/useFlag';

import { RoutePathType } from './enums';

const AUTOMATION_HUB_TO_CUSTOM_AI: Partial<
  Record<RoutePathType, RoutePathType>
> = {
  [RoutePathType.AutomationHub]: RoutePathType.CustomAiHub,
  [RoutePathType.AutomationHubFields]: RoutePathType.CustomAiHubFields,
  [RoutePathType.AutomationHubFieldModel]: RoutePathType.CustomAiHubFieldModel,
  [RoutePathType.AutomationHubFieldsDebug]:
    RoutePathType.CustomAiHubFieldsDebug,
  [RoutePathType.AutomationHubFieldsDebugModel]:
    RoutePathType.CustomAiHubFieldsDebugModel,
  [RoutePathType.AutomationHubDetail]: RoutePathType.CustomAiHubDetail,
  [RoutePathType.RoutingTable]: RoutePathType.CustomAiRoutingTable,
  [RoutePathType.DynamicDataExtraction]: RoutePathType.CustomAiDataExtraction,
  [RoutePathType.ViewDataExtraction]:
    RoutePathType.CustomAiDataExtractionDetail,
  [RoutePathType.XRayLibrary]: RoutePathType.CustomAiLibrary,
  [RoutePathType.XRayLibraryAdmin]: RoutePathType.CustomAiLibraryAdmin,
};

export function resolveAutomationHubPath(
  legacyPath: RoutePathType,
  hasStdAiUrlMigration: boolean,
) {
  if (!hasStdAiUrlMigration) return legacyPath;
  return AUTOMATION_HUB_TO_CUSTOM_AI[legacyPath] ?? legacyPath;
}

export function getAutomationHubPath(legacyPath: RoutePathType) {
  return resolveAutomationHubPath(
    legacyPath,
    getFlag(FlagType.StdAiUrlMigration),
  );
}

export function useAutomationHubPath(legacyPath: RoutePathType) {
  return resolveAutomationHubPath(
    legacyPath,
    useFlag(FlagType.StdAiUrlMigration),
  );
}
